module.exports = __webpack_public_path__ + "static/img/CU.7ca60ee5.svg";